import omit from 'lodash.omit';

import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { removeDescriptionForIri } from 'src/containers/ProjectDiagram/utils/descriptions';
import { removeLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { removeAttributeIrisFromMappings } from 'src/containers/ProjectDiagram/utils/mapping/removeAttributeIrisFromMappings';
import { removePropertyType } from 'src/containers/ProjectDiagram/utils/propertyType/removePropertyType';
import { removeAttributeFromSensitivePropertyGroup } from 'src/containers/ProjectDiagram/utils/sensitivePropertyGroups/removeAttributeFromSensitivePropertyGroup';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

// use useRemoveModelConceptAttribute() since it also
// clears the diagram and closes drawers if necessary
export const removeModelConceptAttribute =
  ({ value }: { value: string }) =>
  (model: Model) => {
    removeAttributeIrisFromMappings(model, value);
    removeDescriptionForIri(value)(model);
    removeLabelForIri(value)(model);
    removePropertyType(value)(model);

    if (model.modelData.attributesByIri[value]) {
      setDataProperty<ModelData>(model)(
        model.modelData,
        'attributesByIri',
        omit(model.modelData.attributesByIri, value)
      );
    }

    // remove the attribute from sensitive property groups
    Object.keys(model.modelData.sensitivePropertyGroupsByName).forEach(
      (groupName) => {
        const existingSensitivePropertyGroup =
          model.modelData.sensitivePropertyGroupsByName[groupName];

        if (existingSensitivePropertyGroup?.includes(value)) {
          removeAttributeFromSensitivePropertyGroup(groupName, value)(model);
        }
      }
    );

    removeAttributeIrisFromMappings(model, value);
  };
